import { DropdownItem, DropdownItemProps } from 'components/ui/DropdownMenu'

export const Action = (props: DropdownItemProps): JSX.Element => <DropdownItem {...props} />

export default Action
